import { render } from "./BootstrapIcons.vue?vue&type=template&id=7d7ece7a"
import script from "./BootstrapIcons.vue?vue&type=script&lang=ts"
export * from "./BootstrapIcons.vue?vue&type=script&lang=ts"
script.render = render

export default script